import React from "react";

interface Props {
  errorState?: boolean;
}

const TopStripIndicator: React.FunctionComponent<Props> = props => {
  return (
    <div
      className={"top-strip-indicator" + (props.errorState ? " error" : "")}
    ></div>
  );
};

export default TopStripIndicator;
